import { render, staticRenderFns } from "./updateOrg.vue?vue&type=template&id=6f4ff9c3&scoped=true&"
import script from "./updateOrg.vue?vue&type=script&lang=js&"
export * from "./updateOrg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4ff9c3",
  null
  
)

export default component.exports